import React from 'react';
import PartnersSectionEditPopup from "./partners_section_edit";
import {connect} from "react-redux";
import {closePartnersSectionPopup, updatePartnersSectionContents} from "../../actions";
import {
    deleteImageFromTheSectionEditPopup,
    updateBodyFieldInTheSectionEditPopup,
    updateImagesInTheSectionEditPopup,
    updateImagesSortOrderInTheSectionEditPopup,
    updateTitleFieldInTheSectionEditPopup
} from "../../sections/actions";

class PartnersPopup extends React.Component {
    render () {
        return (
            <PartnersSectionEditPopup
                open={this.props.partnersSectionEditOpen}
                title={this.props.partnersSectionTitle}
                body={this.props.partnersSectionBody}
                instructions={this.props.partnersSectionInstructions}
                images={this.props.partnersSectionImages}
                pageId={this.props.pageId}
                sectionId={this.props.partnersSectionId}
                onUpdateTitleField={
                    title => this.props.updatePartnersSectionTitleField(title)
                }
                onUpdateBodyField={
                    body => this.props.updatePartnersSectionBodyField(body)
                }
                onUpdateImagesField={
                    (images) => this.props.updatePartnersImagesField(images)
                }
                onUpdateImagesSortOrder={
                    (images) => this.props.updatePartnersImagesSortOrder(images)
                }
                onDeleteImageField={
                    (image, index) => this.props.deletePartnersImageFromSectionField(image, index)
                }
                onUpdateInstructionsField={() => {}}
                onHandleSubmit={() =>
                    this.props.updatePartnersSectionContents(
                        this.props.pageId,
                        this.props.partnersSectionId,
                        this.props.sectionData,
                        this.props.selectedSettings
                    )
                }
                onHandleClose={
                    () => this.props.closePartnersSectionPopup()
                }
            />
        )
    }
}

const mapStateToProps = state => ({
    sectionData: state.pageBuilderSectionPopup.data,
    selectedSettings: state.pageBuilderSectionPopup.settings,
    partnersSectionEditOpen: state.pageBuilder.partnersSectionPopup.open,
    partnersSectionTitle: state.pageBuilderSectionPopup.data.title,
    partnersSectionBody: state.pageBuilderSectionPopup.data.body,
    partnersSectionImages: state.pageBuilderSectionPopup.data.images,
    partnersSectionInstructions: state.pageBuilderSectionPopup.data.instructions,
    partnersSectionId: state.pageBuilderSectionPopup.sectionId,
});

export default connect(
    mapStateToProps, {
        closePartnersSectionPopup: closePartnersSectionPopup,
        updatePartnersSectionTitleField: updateTitleFieldInTheSectionEditPopup,
        updatePartnersSectionBodyField: updateBodyFieldInTheSectionEditPopup,
        updatePartnersSectionContents: updatePartnersSectionContents,
        updatePartnersImagesSortOrder: updateImagesSortOrderInTheSectionEditPopup,
        updatePartnersImagesField: updateImagesInTheSectionEditPopup,
        deletePartnersImageFromSectionField: deleteImageFromTheSectionEditPopup
    }
)(PartnersPopup);


// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/partners_popup.js